import React from "react";
import {Badge, Menu,} from 'antd';
import Link from "redux-first-router-link";

const ConversationList = (props) => {
    const conversations = props.conversations || {};

    const unread = props.unread || {};

    const unreadCount = conversationId => {
        if (unread[conversationId]) {
            return unread[conversationId].length;
        }
        return 0;
    };

    return (
        <Menu theme="dark" defaultSelectedKeys={[]} mode="inline">
            {
                Object.keys(conversations).map(conversation => <Menu.Item key={conversation}><Link
                        to={`/chats/${conversation}`}>{conversation} <Badge
                        count={unreadCount(conversation)}></Badge></Link>

                    </Menu.Item>
                )
            }
        </Menu>
    )
};

export default ConversationList;


// WEBPACK FOOTER //
// ./src/components/admin/ConversationList.js